// extracted by mini-css-extract-plugin
module.exports = {"root":"Messages_root__1kaKv","header":"Messages_header__3YSuL"};